import {RouteDefinition} from '../../../routes';
import {CameraListScreen} from "./CameraListScreen";
import {CameraEditScreen} from './CameraEditScreen';

export const CameraSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/camera/edit',
        component: CameraEditScreen,
    },
    {
        routerLink: '/settings/camera/edit/:id',
        component: CameraEditScreen,
    },
    {
        routerLink: '/settings/camera',
        component: CameraListScreen,
    },
];
